/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { DelphinusCardsGridSectionFragment } from "@cosmos/hygraph-schema";

import { BackgroundContainer, ResponsiveContainer, SectionContainer, SectionHeading } from "@components/elements";
import { VStack } from "@panda/jsx";
import { DelphinusCardsGrid } from "./DelphinusCardsGrid.molecule";

export const DelphinusCardsGridSection = ({
	config,
	grid,
}: DelphinusCardsGridSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(grid?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer disablePaddingBlockEnd={!!config?.disablePaddingBottom}>
					<VStack alignItems="stretch" gap="eds.dimension.48" className="hydrus-column-list-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? <DelphinusCardsGrid grid={grid} /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
